module.exports = __webpack_public_path__ + "static/media/5.aaf734f8.jpg";